import { LegalShell } from "./LegalShell";

export default function Terms() {
  return (
    <LegalShell
      title="Terms of Service"
      subtitle="The ground rules for using heathersboutique.com. By using the site or placing an order, you agree to these terms."
      path="/terms"
      updated="February 12, 2026"
      sections={[
        {
          id: "acceptance",
          heading: "Acceptance of terms",
          body: (
            <p>By creating an account, browsing, or placing an order on heathersboutique.com you agree to be
            bound by these Terms of Service and by our Privacy Policy. If you don't agree, please don't use
            the site.</p>
          ),
        },
        {
          id: "eligibility",
          heading: "Who can use the site",
          body: (
            <>
              <p>You must be at least 13 years old to create an account. Customers under 18 must have a parent
              or legal guardian's permission to place an order. We may refuse service or cancel accounts at
              our discretion for any lawful reason.</p>
            </>
          ),
        },
        {
          id: "account",
          heading: "Your account",
          body: (
            <>
              <p>You're responsible for keeping your password confidential and for all activity that happens
              under your account. If you notice any unauthorized use, contact the store immediately.</p>
              <p>You agree to provide accurate school affiliation, ZIP, and shipping information so our Dress
              Lock guarantee can be honored.</p>
            </>
          ),
        },
        {
          id: "orders",
          heading: "Orders, pricing & availability",
          body: (
            <>
              <p>Placing an order is an offer to buy. We accept the offer when your payment is captured and
              your order confirmation email is sent. Until that moment, we may cancel an order if a product is
              out of stock, mispriced, or otherwise unavailable.</p>
              <p>Prices are shown in US dollars and do not include applicable Wisconsin sales tax, which is
              added at checkout.</p>
            </>
          ),
        },
        {
          id: "dress-lock",
          heading: "The Dress Lock guarantee",
          body: (
            <>
              <p>When you complete purchase of a dress, we register a "Dress Lock" against your school so no
              other verified student from the same school can purchase the same dress in the same color for the
              same event (prom, homecoming, graduation).</p>
              <p>The lock is honored on a first-come, first-locked basis. It applies only to dresses purchased
              through our site with a verified school affiliation and does not extend to items purchased
              elsewhere or to invited guests from other schools.</p>
            </>
          ),
        },
        {
          id: "ai-try-on",
          heading: "AI Try-On credits",
          body: (
            <>
              <p>Every account receives one free AI Try-On. Additional try-on credits may be purchased in
              packs (5 for $3.99, 10 for $7.99, 20 for $9.99).</p>
              <p><b>AI Try-On credits are non-refundable digital goods.</b> Unused credits do not expire but
              cannot be transferred to another account.</p>
              <p>By uploading a selfie you affirm that (a) you are the person in the photo or have their
              permission, and (b) you grant us the limited right to send it to our AI provider so we can
              generate your result. You retain ownership of your photo; we retain no other rights.</p>
            </>
          ),
        },
        {
          id: "user-content",
          heading: "Content you post",
          body: (
            <p>If you share a try-on result or lookbook memory publicly, you grant us a non-exclusive,
            worldwide, royalty-free license to display it on our site and social channels to promote the
            boutique. You can delete your content anytime and we'll remove the license.</p>
          ),
        },
        {
          id: "returns",
          heading: "Returns & refunds",
          body: (
            <p>See our <a className="text-rosemetal" href="/returns">Returns Policy</a> for full details on
            dresses. Digital goods (AI Try-On credits, gift cards) are final sale.</p>
          ),
        },
        {
          id: "prohibited",
          heading: "Prohibited uses",
          body: (
            <>
              <p>You may not use the site to:</p>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>Upload photos of anyone who hasn't consented</li>
                <li>Upload sexually explicit, illegal, or hateful content</li>
                <li>Attempt to circumvent our security, rate limits, or dress-lock rules</li>
                <li>Scrape or resell our catalog data</li>
                <li>Impersonate another person or misrepresent your school</li>
              </ul>
              <p>Violation may result in account suspension and forfeit of unused credits.</p>
            </>
          ),
        },
        {
          id: "warranty-disclaimer",
          heading: "Warranty disclaimer",
          body: (
            <p>The site is provided "as is." We work hard to keep it accurate and available, but we don't
            promise it's error-free or uninterrupted. All warranties beyond those required by law are
            disclaimed to the fullest extent permitted.</p>
          ),
        },
        {
          id: "liability",
          heading: "Limitation of liability",
          body: (
            <p>To the maximum extent permitted by Wisconsin law, our total liability to you for any claim
            arising out of your use of the site or a purchase is limited to the amount you paid us in the
            12 months preceding the claim. We are not liable for indirect, incidental, or consequential
            damages.</p>
          ),
        },
        {
          id: "governing-law",
          heading: "Governing law & disputes",
          body: (
            <p>These Terms are governed by the laws of the State of Wisconsin, USA. Any dispute will be
            resolved in the state or federal courts located in Waukesha County, Wisconsin, and you consent
            to their exclusive jurisdiction.</p>
          ),
        },
        {
          id: "changes",
          heading: "Changes",
          body: (
            <p>We may update these Terms occasionally. We'll email registered users about material changes at
            least 14 days before they take effect. Continued use of the site after that date means you
            accept the update.</p>
          ),
        },
      ]}
    />
  );
}
